import { Campaign, ClosingMethod } from 'services/campaign/types';

const closingMethodTextByClosingMethod = {
  [ClosingMethod.CUSTOM]: 'Send message',
  [ClosingMethod.MEETING_URL]: 'Meeting URL',
  [ClosingMethod.PHONE_NUMBER]: 'Phone number',
  [ClosingMethod.CALENDAR_MEETING_INTEGRATION]:
    'Ask candidates to schedule a meeting'
};

export type ContentItem = {
  title?: string;
  content: string;
};

export const buildContentList = (campaign: Campaign): ContentItem[] => {
  const contentList: ContentItem[] = [];

  if (campaign.customTemplatedMessage) {
    const subjectPrefix = campaign.customTemplatedSubjectLine?.length
      ? `Subject: ${campaign.customTemplatedSubjectLine}\n\n`
      : '';

    contentList.push({
      title: 'Opening message',
      content: `${subjectPrefix}${campaign.customTemplatedMessage}`
    });
  }

  contentList.push({
    title: 'Candidate successful',
    content: campaign.closingMethod
      ? closingMethodTextByClosingMethod[campaign.closingMethod]
      : 'None'
  });

  if (campaign.closingMethod === ClosingMethod.CALENDAR_MEETING_INTEGRATION) {
    contentList.push({
      title: 'Calendar meeting template',
      content: campaign.calendarMeetingTemplate?.title || 'None'
    });
  }

  contentList.push({
    content:
      campaign.contactNumber ||
      campaign.meetingUrl ||
      campaign.customRequest ||
      ''
  });

  contentList.push({
    title: 'Candidate unsuccessful',
    content: campaign.rejectionMessage || 'None'
  });

  contentList.push({
    title: 'Candidate not interested',
    content: campaign.closingMessage || 'None'
  });

  const days = campaign.timeToAutoCloseConversationsInHours
    ? campaign.timeToAutoCloseConversationsInHours / 24
    : null;
  contentList.push({
    title: 'Close conversation delay',
    content: days ? `${days} day${days > 1 ? 's' : ''}` : 'None'
  });

  return contentList;
};
